import { render, staticRenderFns } from "./PrintHeader.vue?vue&type=template&id=befd97e8&scoped=true&"
import script from "./PrintHeader.vue?vue&type=script&lang=js&"
export * from "./PrintHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrintHeader.vue?vue&type=style&index=0&id=befd97e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befd97e8",
  null
  
)

export default component.exports